import React from 'react';
import { InputProps } from '../../types';
import './Input.css';

const Input: React.FC<InputProps> = ({ 
  type = 'text',
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  className = '',
  disabled = false,
  required = false,
  min,
  max,
  step,
  maxLength,
  error
}) => {
  const inputClasses = `input ${className}`.trim();
  
  return (
    <div className="input-container">
      {label && (
        <label htmlFor={id} className="input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={inputClasses}
        disabled={disabled}
        required={required}
        min={min}
        max={max}
        step={step}
        maxLength={maxLength}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Input;
